export default {
  GET_WORK_INSTRUCTION_PACKAGES: (state) => {
    return state.workInstructionPackages;
  },
  CURRENT_WORK_INSTRUCTION_PACKAGE: (state) => {
    return state.currentWorkInstructionPackage;
  },
  GET_WORK_INSTRUCTION: (state) => {
    return state.currentWorkInstruction;
  },
};
